/* Tha Layover — premium header: scroll state + predictive search */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-tl-header]');
  if (!wrap) return;

  /* scroll state */
  if (wrap.classList.contains('is-sticky')) {
    var ticking = false;
    /* Horizon scrolls inside .page-wrapper; listen to both it and the window */
    var pw = document.querySelector('.page-wrapper');
    var onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = Math.max(window.scrollY, pw ? pw.scrollTop : 0);
        wrap.classList.toggle('is-scrolled', y > 24); ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* cart badge bump */
  var badge = wrap.querySelector('.tl-count');
  if (badge && 'MutationObserver' in window) {
    new MutationObserver(function () {
      badge.classList.remove('tl-bump'); void badge.offsetWidth; badge.classList.add('tl-bump');
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* search */
  var search = document.getElementById('TLSearch');
  if (!search) return;
  var input = search.querySelector('[data-search-input]');
  var results = search.querySelector('[data-search-results]');
  var hintHTML = results.innerHTML;
  var panel = search.querySelector('.tl-search-panel');
  var predictiveUrl = search.getAttribute('data-predictive-url');
  var searchUrl = search.getAttribute('data-search-url');
  var moneyFormat = search.getAttribute('data-money-format') || '${{amount}}';
  var labels = {
    all: search.getAttribute('data-view-all') || 'View all results',
    none: search.getAttribute('data-empty') || 'No products found for',
    heading: search.getAttribute('data-products-heading') || 'Products'
  };
  var lastFocus = null, timer = null, controller = null;

  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    if (isNaN(n)) return '';
    if (typeof v === 'number' && v > 999 && String(v).indexOf('.') === -1) n = v / 100;
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0]).replace(/\{\{\s*amount\s*\}\}/g, parts.join('.'));
  }
  function img(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  function open(e) {
    if (e) e.preventDefault();
    lastFocus = document.activeElement;
    search.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tl-search-open');
    setTimeout(function () { input.focus({ preventScroll: true }); }, 120);
  }
  function close() {
    search.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tl-search-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function render(q, products) {
    if (!products.length) {
      results.innerHTML = '<p class="tl-search-none">' + esc(labels.none) + ' “' + esc(q) + '”</p>';
      return;
    }
    results.innerHTML = '<p class="tl-search-label">' + esc(labels.heading) + '</p><div class="tl-search-grid">' +
      products.map(function (p, i) {
        var src = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return '<div class="tl-search-card" style="--i:' + i + '"><a href="' + esc(p.url) + '">' +
          '<div class="tl-search-card-img">' + (src ? '<img src="' + esc(img(src, 480)) + '" alt="' + esc(p.title) + '" loading="lazy" width="480" height="600">' : '') + '</div>' +
          '<h4>' + esc(p.title) + '</h4>' + (p.price != null ? '<p>' + money(p.price) + '</p>' : '') + '</a></div>';
      }).join('') + '</div>' +
      '<a class="tl-search-all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(labels.all) +
      ' <svg width="18" height="10" viewBox="0 0 24 12" fill="none" aria-hidden="true"><path d="M0 6h22m-5-5 5 5-5 5" stroke="currentColor" stroke-width="1.4"/></svg></a>';
  }

  function query(q) {
    if (controller) controller.abort();
    if (q.length < 2) { results.innerHTML = hintHTML; return; }
    controller = 'AbortController' in window ? new AbortController() : null;
    results.classList.add('tl-search-loading');
    var url = predictiveUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        results.classList.remove('tl-search-loading');
        render(q, (d && d.resources && d.resources.results && d.resources.results.products) || []);
      })
      .catch(function (err) { if (err && err.name === 'AbortError') return; results.classList.remove('tl-search-loading'); });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    timer = setTimeout(function () { query(q); }, 220);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { open(e); return; }
    if (e.target.closest('[data-search-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    var isOpen = search.getAttribute('aria-hidden') === 'false';
    if (isOpen && e.key === 'Escape') { close(); return; }
    if (isOpen && e.key === 'Tab') {
      var f = Array.prototype.filter.call(panel.querySelectorAll('a[href],button,input:not([type=hidden])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      return;
    }
    var t = e.target, typing = t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName));
    if (!isOpen && !typing && e.key === '/') open(e);
  });
})();
